module.exports = __webpack_public_path__ + "assets/favicons/apple-touch-icon.e5a894298a1cdbdfa0fbdd7414e6930c.png";